import classNames from 'classnames';
import React from 'react';

import * as styles from './SnapSlider.module.scss';

const SnapSlider = ({ className, children, isHero, ...other }) => {
  const containerClass = classNames(
    { [ styles.isHero ]: isHero },
    className
  );

  return (
    <div {...other} className={containerClass}>
      <ul className={styles.itemContainer}>
        {React.Children.map(children, (child, index) => (
          <li className={styles.item} key={index}>
            {child}
          </li>
        ))}
      </ul>
    </div>
  );
};

SnapSlider.propTypes = {};

export default SnapSlider;
